import { CSSProperties } from "react";

// Use CSS variable for tooltip background, fallback to original color
const getTooltipBackground = (): string => {
  if (typeof window !== "undefined") {
    const root = document.documentElement;
    const tooltipBg = getComputedStyle(root)
      .getPropertyValue("--color-tooltip-background")
      .trim();
    if (tooltipBg) return tooltipBg;
  }
  return "rgba(36, 43, 67, .9)";
};

const getTooltipColor = (): string => {
  if (typeof window !== "undefined") {
    const root = document.documentElement;
    const tooltipColor = getComputedStyle(root)
      .getPropertyValue("--color-tooltip-text")
      .trim();
    if (tooltipColor) return tooltipColor;
  }
  return "#FFFFFF";
};

export const TOOLTIP_STYLE: CSSProperties = {
  position: "absolute",
  textAlign: "center",
  overflow: "hidden",
  padding: "5px 10px",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "20px",
  maxWidth: "300px",
  width: "max-content",
  borderRadius: "5px",
  zIndex: 1000,
  backgroundColor: getTooltipBackground(),
  color: getTooltipColor(),
};

export const TOOLTIP_EXTRA_SPACE: number = 10;

export const TOOLTIP_SPACE_BETWEEN_ELEMENT: number = 5;
